module.exports = __webpack_public_path__ + "static/media/icon-module-audit-management-hover.0e65d01f.svg";